import { X } from 'lucide-react';

// iter599 — Kiosk-mode "Exit" pill. Tiny, top-right, only visible
// when ?kiosk=1 is active. The button is the only sanctioned way
// out (back-button is trapped, pop-up close may not be available
// on tablets that opened in the same tab).
export const KioskExitPill = ({ onExit }) => (
  <button
    type="button"
    onClick={onExit}
    className="fixed top-2 right-2 z-[100] bg-white/95 hover:bg-white border border-stone-300 shadow-md rounded-full px-3 py-1 text-[11px] font-medium text-stone-600 hover:text-stone-900 flex items-center gap-1.5 transition-colors"
    data-testid="exit-kiosk-btn"
    title="Exit kiosk mode"
  >
    <X size={12} /> Exit Kiosk
  </button>
);

export default KioskExitPill;
